import { FC, useCallback } from 'react'
import useChatNew from '../hooks/useChat'
import ChatLayout from '../layout'
import { TChatScreen } from '../types'
import ChatHistoryScreen from './ChatHistoryScreen'

const ChatWidget: FC<{
 show?: boolean
 onClose?: () => void
}> = () => {
 const { state, toggleInviteModal } = useChatNew()

 const buildScreen = useCallback((type?: TChatScreen) => {
  switch (type) {
   case 'chatHistory':
    return <ChatHistoryScreen />
   default:
    return null
  }
 }, [])

 return (
  <>
   <ChatLayout>{buildScreen(state?.screen)}</ChatLayout>

   {/* {state.showInviteModal && (
    <InviteFriend
     type={state.property?.listing_type}
     onHide={() => toggleInviteModal?.(false)}
     slug={state.property?.slug ?? ''}
     show={state.showInviteModal}
    />
   )} */}
  </>
 )
}

export default ChatWidget
